import { isLaunchReadyPath } from "@/lib/launch-gating";

/**
 * Pages that are built but not launched, and that only the platform's own
 * preview audience may open. A path here is open to `roles` while it is
 * absent from `LAUNCH_READY_PATHS`; the moment it is launched the normal
 * role allow-list (`lib/role-access.ts`) and router guards take over.
 *
 * `/neural` is a client-side simulation (random "focus" numbers, no API, no
 * device). It must never reach a pupil or a family, who would read the
 * generated "mental fatigue" advice as a real signal about them.
 */
const PREVIEW_ONLY_ROLES: Readonly<Record<string, readonly string[]>> = {
  "/neural": ["CHAIRMAN", "CONTROL_CENTER"],
};

/**
 * True when `role` may open `path`. A path that is not registered as
 * preview-only is not this module's business and always passes; a
 * registered one passes once it is launched, or for its preview roles.
 */
export function canOpenPreviewPath(role: string | null | undefined, path: string): boolean {
  const roles = PREVIEW_ONLY_ROLES[path];
  if (!roles) return true;
  if (isLaunchReadyPath(path)) return true;
  return !!role && roles.includes(role);
}
